import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import http from "../../../BaseUrl"


const singIn = createAsyncThunk("/auth/singIn", async (value, data) => {

    try {
        const response = await http.post("/admin/adminLogin", {

            email: value.email,
            password: value.password,
        })
        if (response.status === 200) {
            return response.data
        }
    } catch (err) {
        return err.response.data
    }
})

const addStudent = createAsyncThunk("/auth/addStudent", async (value, data) => {

    try {
        const response = await http.post("/users/registerUser", {

            email: value.email,
            name: value.name,
            paid_account: value.paid_account,
        })
        if (response.status === 200) {
            return response.data
        }
        console.log("add student response----> ", response);

    } catch (err) {
        return err.response.data
    }
})

const changePassword = createAsyncThunk("/auth/changePassword", async (value) => {
    try {
        const response = await http.put("/admin/updatePassword", {
            currentPassword: value.currentPassword,
            newPassword: value.newPassword
        });
        return response.data;
    } catch (err) {
        return err.response.data;
    }
});

const changeUserPassword = createAsyncThunk("/auth/changeUserPassword", async ({ userId, password }) => {
    try {
        const response = await http.put(`/admin/updateUserPassword/${userId}`, {
            password
        });
        return response.data;
    } catch (err) {
        return err.response.data;
    }
});

const updatePassword = createAsyncThunk("/auth/updatePassword", async (value) => {
    try {
        const response = await http.put(`/users/updatePassword/${value.id.id}`, {

            password: value.data,

        })

        return response.data
    } catch (err) {
        return err.response.data

    }
})

const deleteUser = createAsyncThunk("/auth/deleteUser", async (id) => {

    try {
        const response = await http.delete(`/admin/deleteUser/${id}`);

        return response
    } catch (err) {
        return err.response.data

    }
})

const resetUserDevice = createAsyncThunk("/auth/resetUserDevice", async (id) => {

    try {
        const response = await http.put(`/admin/resetUserDevice/${id}`);
        return response
    } catch (err) {
        return err.response.data

    }
})

const bulkAction = createAsyncThunk("/auth/bulkAction", async (payload) => {

    try {
        const response = await http.post(`/admin/userBulkAction`, payload);
        return response.data
    } catch (err) {
        return err.response.data

    }
})

const hideCoursesForBulkStudent = createAsyncThunk("/auth/hideCoursesForBulkStudent", async (payload) => {

    try {
        const response = await http.post(`/admin/hideCoursesForBulkStudent`, payload);
        return response.data
    } catch (err) {
        return err.response.data

    }
})

const updateAdmin = createAsyncThunk("/auth/updateAdmin", async (value) => {

    try {
        const response = await http.put(`/admin/updateAdmin`, {

            name: value.name,
            phone: value.phone,

        })
        console.log("response", response);
        return response.data
    } catch (err) {
        console.log("errrorrrr", err);
    }
})

const updateYoutube = createAsyncThunk(
    "auth/updateYoutube",
    async ({ videoId, active }, { rejectWithValue }) => {

        try {
            const response = await http.put(`/admin/ActiveInactiveVideo/${videoId}`, {
                active, // 🔄 Send boolean value
            });
            if (response.status == 200) {
                return response.data; // Return updated user data
            }
        } catch (err) {
            return rejectWithValue(err.response?.data || "Error blocking student");
        }
    }
);

const sendNotification = createAsyncThunk(
    "auth/sendNotification",
    async ({ deviceTokens, userIds, message, title }, { rejectWithValue }) => {
        try {
            const response = await http.post(`/admin/sendNotification`, {
                deviceTokens,
                userIds,
                message,
                title
            });

            if (response.status === 200) {
                return response.data; // Return notification processing results
            }

            throw new Error('Unexpected response status');
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message || "Error sending notification");
        }
    }
);

const getAdminData = createAsyncThunk("/auth/getAdminData", async (value) => {
    try {

        const response = await http.get(`/admin/getAdmin`)
        if (response.status === 200) {
            return response.data
        }

    } catch (err) {
        if (err.response.status === 400) {
            return err.response.data
        }
    }
})

const getCoursesVideos = createAsyncThunk("/auth/getCoursesVideos", async () => {

    try {

        const response = await http.get(`/courseExtra/getCoursesAllVideos`)
        if (response.status === 200) {
            return response
        }

    } catch (err) {
        if (err.status === 400) {
            return err.data.message
        }
    }
})

const getCoursesDetail = createAsyncThunk("/auth/getCoursesDetail", async () => {

    try {

        const response = await http.get(`/courseExtra/getCoursesDetails`)
        if (response.status === 200) {
            return response
        }

    } catch (err) {
        if (err.status === 400) {
            return err.data.message
        }
    }
})

const getAllCoursesDetail = createAsyncThunk("/auth/getAllCoursesDetail", async () => {

    try {

        const response = await http.get(`/admin/getAllCoursesDetails`)
        if (response.status === 200) {
            return response?.data
        }

    } catch (err) {
        if (err.status === 400) {
            return err.data.message
        }
    }
})

const popUp = createAsyncThunk("/auth/popUp", async (value) => {

    return value
})

const passwordeye = createAsyncThunk("/auth/passwordeye", async (value) => {

    return value
})

const confirmpasswordeye = createAsyncThunk("/auth/confirmpasswordeye", async (value) => {

    return value
})

const paidUnpaidStudent = createAsyncThunk(
    "adminDashboard/paidUnpaidStudent",
    async ({ userId, paid }, { rejectWithValue }) => {
        try {
            const response = await http.put(`/admin/paidUnpaidStudent/${userId}`, {
                paid, // 🔄 Send boolean value
            });

            console.log("response", response);

            if (response.status === 200) {
                return response.data; // Return updated user data
            }
        } catch (err) {
            return rejectWithValue(err.response?.data || "Error updating paid status");
        }
    }
);

const blockStudent = createAsyncThunk(
    "adminDashboard/blockStudent",
    async ({ userId, blocked }, { rejectWithValue }) => {

        try {
            const response = await http.put(`/admin/blockStudent/${userId}`, {
                blocked, // 🔄 Send boolean value
            });
            if (response.status == 200) {
                return response.data; // Return updated user data
            }
        } catch (err) {
            return rejectWithValue(err.response?.data || "Error blocking student");
        }
    }
);

const createCourses = createAsyncThunk("/dashboard/createCourses", async (FormData) => {

    try {

        const response = await http.post("/courseExtra/createCourse", FormData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Set the correct content type for FormData
            },

        })
        console.log("response", response);

        if (response.status === 200) {
            return response.data
        }
    }
    catch (err) {
        return err.response.data
    }
})

const updateCourse = createAsyncThunk("/dashboard/updateCourse", async ({ courseId, FormData }) => {

    try {

        const response = await http.put(`/courseExtra/updateCourse/${courseId}`, FormData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Set the correct content type for FormData
            },

        })

        if (response.status === 200) {
            return response.data
        }
    }
    catch (err) {
        return err.response.data
    }
})

const initialState = {
    successMsg: null,
    showPopup: false,
    changePass: [],
    deleteUser: [],
    resetUserDevice: [],
    updateYoutubes: [],
    updateYoutubes: [],
    getCoursesVideo: [],
    sendNotifications: [],
    blockStudents: [],
    getCoursesDetails: [],
    getAllBulkCoursesDetails: [],
    changeStudentPass: [],
    showpassword: false,
    showconfirmpassword: false,
    getAdminAllData: [],
    loader: false,
    allCoursesLoader: false,

}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    extraReducers: (builder) => {
        builder

            // Change Admin password
            .addCase(changePassword.pending, (state, action) => { state.loader = true })
            .addCase(changePassword.fulfilled, (state, action) => {
                state.changePass = action.payload
                state.showPopup = true
                state.loader = false

            })
            .addCase(changePassword.rejected, (state, action) => { state.loader = false })

            // Change User password
            .addCase(changeUserPassword.pending, (state, action) => { state.loader = true })
            .addCase(changeUserPassword.fulfilled, (state, action) => {
                state.changeStudentPass = action.payload
                state.showPopup = true
                state.loader = false

            })
            .addCase(changeUserPassword.rejected, (state, action) => { state.loader = false })


            //update password
            .addCase(updatePassword.pending, (state, action) => { state.loader = true })
            .addCase(updatePassword.fulfilled, (state, action) => {
                state.changePass = action.payload;
                state.showPopup = true
                state.loader = false

            })
            .addCase(updatePassword.rejected, (state, action) => { state.loader = false })

            // create Course
            .addCase(createCourses.pending, (state, action) => { state.loader = true })
            .addCase(createCourses.fulfilled, (state, action) => {
                state.createCourses = action.payload
                state.showPopup = true
                state.loader = false
            })
            .addCase(createCourses.rejected, (state, action) => { state.loader = false })

            // Update Course
            .addCase(updateCourse.pending, (state, action) => { state.loader = true })
            .addCase(updateCourse.fulfilled, (state, action) => {
                state.updateCourses = action.payload
                state.showPopup = true
                state.loader = false
            })
            .addCase(updateCourse.rejected, (state, action) => { state.loader = false })


            // Paid/Unpaid Student
            .addCase(paidUnpaidStudent.pending, (state) => {
                state.loader = false;
            })
            .addCase(paidUnpaidStudent.fulfilled, (state, action) => {
                state.loader = false;
                state.showPopup = true


            })
            .addCase(paidUnpaidStudent.rejected, (state, action) => {
                state.loader = false;
                state.error = action.payload;
            })


            // Block Student
            .addCase(blockStudent.pending, (state) => {
                state.loader = false;
            })
            .addCase(blockStudent.fulfilled, (state, action) => {
                state.loader = false;
                state.showPopup = true
                state.blockStudents = action.payload;

            })
            .addCase(blockStudent.rejected, (state, action) => {
                state.loader = false;
                state.error = action.payload;
            })

            // delete User
            .addCase(deleteUser.pending, (state, action) => { state.loader = true })
            .addCase(deleteUser.fulfilled, (state, action) => {
                state.deleteUser = action.payload;
                state.showPopup = true
                state.loader = false

            })
            .addCase(deleteUser.rejected, (state, action) => { state.loader = false })

            // Reset User Device
            .addCase(resetUserDevice.pending, (state, action) => { state.loader = true })
            .addCase(resetUserDevice.fulfilled, (state, action) => {
                state.resetUserDevice = action.payload;
                state.showPopup = true
                state.loader = false

            })
            .addCase(resetUserDevice.rejected, (state, action) => { state.loader = false })

            // Bulk Action
            .addCase(bulkAction.pending, (state, action) => { state.loader = true })
            .addCase(bulkAction.fulfilled, (state, action) => {
                state.showPopup = true
                state.loader = false

            })
            .addCase(bulkAction.rejected, (state, action) => { state.loader = false })

            // Hide Courses For Bulk Student
            .addCase(hideCoursesForBulkStudent.pending, (state, action) => { state.loader = true })
            .addCase(hideCoursesForBulkStudent.fulfilled, (state, action) => {
                state.showPopup = true
                state.loader = false

            })
            .addCase(hideCoursesForBulkStudent.rejected, (state, action) => { state.loader = false })

            //Get Admin
            .addCase(getAdminData.pending, (state, action) => { state.loader = true })
            .addCase(getAdminData.fulfilled, (state, action) => {
                state.getAdminAllData = action.payload.data;
                state.showPopup = true
                state.loader = false

            })
            .addCase(getAdminData.rejected, (state, action) => { state.loader = false })

            //update User
            .addCase(updateAdmin.pending, (state, action) => { state.loader = true })
            .addCase(updateAdmin.fulfilled, (state, action) => {
                state.showPopup = true
                state.loader = false

            })
            .addCase(updateAdmin.rejected, (state, action) => { state.loader = false })


            //login/signin form
            .addCase(singIn.pending, (state, action) => { state.loader = true })
            .addCase(singIn.fulfilled, (state, action) => {
                state.showPopup = true
                state.show = false
                state.loader = false
            })
            .addCase(singIn.rejected, (state, action) => { state.loader = false })

            // Active or Inactive Youtube
            .addCase(updateYoutube.pending, (state) => {
                state.loader = false;
            })
            .addCase(updateYoutube.fulfilled, (state, action) => {
                state.updateYoutubes = action.payload;
                state.loader = false;
                state.showPopup = true

            })
            .addCase(updateYoutube.rejected, (state, action) => {
                state.loader = false;
                state.error = action.payload;
            })

            // send Notification
            .addCase(sendNotification.pending, (state) => {
                state.loader = true;
            })
            .addCase(sendNotification.fulfilled, (state, action) => {
                state.sendNotifications = action.payload;
                state.showPopup = true
                state.loader = false;

            })
            .addCase(sendNotification.rejected, (state, action) => {
                state.loader = false;
                state.error = action.payload;
            })

            // Add Students
            .addCase(addStudent.pending, (state, action) => { state.loader = true })
            .addCase(addStudent.fulfilled, (state, action) => {
                console.log("add student", action);
                state.showPopup = true
                state.show = false
                state.loader = false
            })
            .addCase(addStudent.rejected, (state, action) => { state.loader = false })

            // Get All Courses Videos
            .addCase(getCoursesVideos.pending, (state, action) => { state.loader = true })
            .addCase(getCoursesVideos.fulfilled, (state, action) => {
                state.getCoursesVideo = action.payload.data.data
                state.loader = false

            })
            .addCase(getCoursesVideos.rejected, (state, action) => { state.loader = false })

            // Get All Courses Details
            .addCase(getCoursesDetail.pending, (state, action) => { state.loader = true })
            .addCase(getCoursesDetail.fulfilled, (state, action) => {
                state.getCoursesDetails = action.payload.data.data
                state.loader = false

            })
            .addCase(getCoursesDetail.rejected, (state, action) => { state.loader = false })

            // Get All Courses Details
            .addCase(getAllCoursesDetail.pending, (state, action) => { state.allCoursesLoader = true })
            .addCase(getAllCoursesDetail.fulfilled, (state, action) => {
                state.getAllBulkCoursesDetails = action.payload.data
                state.allCoursesLoader = false

            })
            .addCase(getAllCoursesDetail.rejected, (state, action) => { state.allCoursesLoader = false })

            //message popup
            .addCase(popUp.pending, (state, action) => { state.loader = true })
            .addCase(popUp.fulfilled, (state, action) => {

                state.showPopup = action.payload
                state.loader = false

            })
            .addCase(popUp.rejected, (state, action) => { state.loader = false })

            //password eye
            .addCase(passwordeye.pending, (state, action) => { })
            .addCase(passwordeye.fulfilled, (state, action) => {
                state.showpassword = action.payload
            })
            .addCase(passwordeye.rejected, (state, action) => { })

            //Confirm password eye
            .addCase(confirmpasswordeye.pending, (state, action) => { })
            .addCase(confirmpasswordeye.fulfilled, (state, action) => {
                state.showconfirmpassword = action.payload
            })
            .addCase(confirmpasswordeye.rejected, (state, action) => { })

    }
})
export { changePassword, changeUserPassword, paidUnpaidStudent, updateCourse, createCourses, blockStudent, hideCoursesForBulkStudent, sendNotification, getCoursesVideos, getCoursesDetail, updateYoutube, resetUserDevice, deleteUser, singIn, popUp, addStudent, updatePassword, updateAdmin, passwordeye, confirmpasswordeye, getAdminData, bulkAction, getAllCoursesDetail }
export default authSlice.reducer